(function (window) {
  'use strict';

  /**
   * Debounce function.
   *
   * @param {Function} func Function fot to peforme.
   * @param {Number} timeout Timeout in milisseconds
   * @returns {Null}
   */
  function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  /**
   * Format money
   * @param {Number} money
   * @param {String} country
   * @param {String} currency
   * @returns {String}
   */
  function formatMoney(money, country = 'pt-BR', currency = 'BRL') {
    return new Intl.NumberFormat(country, { style: 'currency', currency: currency }).format(money);
  }

  /**
   * Get item
   *
   * @param {String} key String for to save into browser storage
   * @returns
   */
  function getItem(key) {
    return window.localStorage.getItem(key) || [];
  }

  /**
   * Has item
   *
   * @param {String} key Storage index for get data
   * @param {String} value Value for to search into storage
   * @returns
   */
  function hasItem(key, value) {
    const data = getItem(key);

    return data.some((item) => item == value);
  }

  /**
   * Save item
   *
   * @param {String} key Storage index
   * @param {String} value Value for save
   */
  function saveItem(key, value) {
    window.localStorage.setItem(key, JSON.stringify(data));
  }

  class MobileNavigation extends HTMLElement {
    constructor() {
      super();

      this.closeMobileMenu = this.querySelector('.mobile-navigation__button-close');
      this.menuButton = Array.from(document.querySelectorAll('[aria-controls="menu-mobile"]'));
      this.superLinks = Array.from(
        this.querySelectorAll('.mobile-navigation__menu-item--has-child > .mobile-navigation__item-link')
      );
      this.menuBlockTitle = Array.from(
        this.querySelectorAll('.mobile-navigation__menu-block > .mobile-navigation__item-title')
      );
      this.menuButtonListener = this._menuButton.bind(this);
      this.openSubmenuListener = this._openSubmenu.bind(this);
      this.closeMenuBlockListener = this._closeMenuBlock.bind(this);
      this.closeMobileMenuListener = this._closeMobileMenu.bind(this);
    }
    connectedCallback() {
      this.addEventListener('click', (e) => {
        if (e.target.classList.contains('mobile-navigation')) {
          this._closeMobileMenu();
        }
      });
      document.addEventListener('keyup', (e) => {
        if (e.code === 'Escape') {
          this._closeMobileMenu();
        }
      });
      this.closeMobileMenu.addEventListener('click', this.closeMobileMenuListener);
      this.menuButton.forEach((button) => {
        button.addEventListener('click', this.menuButtonListener);
      });
      this.superLinks.forEach((link) => {
        link.addEventListener('click', this.openSubmenuListener);
      });
      this.menuBlockTitle.forEach((title) => {
        title.addEventListener('click', this.closeMenuBlockListener);
      });
    }
    disconnectedCallback() {
      this.removeEventListener('click', (e) => {
        if (e.target.classList.contains('mobile-navigation')) {
          this._closeMobileMenu();
        }
      });
      document.removeEventListener('keyup', (e) => {
        if (e.code === 'Escape') {
          this._closeMobileMenu();
        }
      });
      this.closeMobileMenu.removeEventListener('click', this.closeMobileMenuListener);
      this.menuButton.forEach((button) => {
        button.removeEventListener('click', this.menuButtonListener);
      });
      this.superLinks.forEach((link) => {
        link.removeEventListener('click', this.openSubmenuListener);
      });
      this.menuBlockTitle.forEach((title) => {
        title.removeEventListener('click', this.closeMenuBlockListener);
      });
    }
    _menuButton() {
      this.classList.add('active');
    }
    _closeMobileMenu() {
      this.classList.remove('active');

      setTimeout(() => {
        this.querySelectorAll('.active').forEach((el) => {
          el.classList.remove('active');
        });
      }, 300);
    }
    _openSubmenu(e) {
      e.preventDefault();

      const menuItem = e.currentTarget.parentNode;
      const menuBlock = e.currentTarget.closest('.mobile-navigation__menu-block');

      if (menuBlock && menuItem) {
        menuItem.classList.add('active');
        menuBlock.classList.add('active');
      }
    }
    _closeMenuBlock(e) {
      e.preventDefault();

      const menuItem = e.currentTarget.closest('.mobile-navigation__menu-item');
      const menuBlock = e.currentTarget.closest('.mobile-navigation__menu-block.active');

      if (menuBlock && menuItem) {
        menuItem.classList.remove('active');
        menuBlock.classList.remove('active');
      }
    }
  }
  if (!window.customElements.get('mobile-navigation')) {
    window.customElements.define('mobile-navigation', MobileNavigation);
  }

  class HeaderSearch extends HTMLElement {
    constructor() {
      super();

      this.suggestions = this.querySelector('#search-results').innerHTML;
      this.input = this.querySelector('[name="q"]');
      this.typingListener = this._typing.bind(this);
      this.focusListener = this._focus.bind(this);
      this.buttonClose = this.querySelector('.header-search__button--close');
      this.closeSearchListener = this._closeSearch.bind(this);
      this.termClickListener = this._termClick.bind(this);
    }
    connectedCallback() {
      this.input.addEventListener('input', debounce(this.typingListener));
      this.input.addEventListener('focus', this.focusListener);
      this.buttonClose.addEventListener('click', this.closeSearchListener);
      document.addEventListener('click', (e) => {
        if (!e.target.classList.contains('search-suggestion')) {
          if (!e.target.closest('.header-search')) {
            this._closeSearch(e);
          }
        }
      });
      document.addEventListener('keyup', (e) => {
        if (e.code === 'Escape') {
          this._closeSearch(e);
        }
      });
      document.addEventListener('term:click', this.termClickListener);
    }
    _termClick(e) {
      e.preventDefault();

      this.input.value = e.detail.term;
      this._request(this.input.value);
    }
    _closeSearch(e) {
      this.classList.remove('active');
    }
    _searching() {
      return '<div class="header-search__no-type"><p class="search-results__loading"><span class="spinner"></span>Buscando resultados...</p></div>';
    }
    _focus(e) {
      this.classList.add('active');
    }
    _serchSuggestionList() {
      return this.suggestions;
    }
    _request(term) {
      const results = this.querySelector('#search-results');

      if (this.input.value === '') {
        results.innerHTML = this._serchSuggestionList();
        return;
      }

      results.innerHTML = this._searching();

      fetch(
        window.Shopify.routes.root +
          'search/suggest?q=' +
          term +
          '&resources[limit]=10&resources[limit_scope]=each&section_id=predictive-search',
        {
          method: 'GET',
        }
      )
        .then((r) => r.text())
        .then((result) => {
          const resultHtml = new DOMParser().parseFromString(result, 'text/html');
          this.querySelector('#search-results').replaceWith(
            document.importNode(resultHtml.querySelector('#shopify-section-predictive-search'), true)
          );

          this.querySelector('.search-resilts__all-results > a').href = '/search?q=' + term;

          this.querySelector('.header-search__results-tab').click();
        })
        .catch((err) => {
          console.error(err);
        });
    }
    _typing(e) {
      e.preventDefault();

      this._request(this.input.value);
    }
  }
  if (!window.customElements.get('header-search')) {
    window.customElements.define('header-search', HeaderSearch);
  }

  class PredictiveSearchResults extends HTMLElement {
    constructor() {
      super();

      this.tabs = Array.from(this.querySelectorAll('.header-search__results-tab'));
      this.cards = Array.from(this.querySelectorAll('.predictive-search__result'));
      this.changeTabListener = this._changeTab.bind(this);
    }
    connectedCallback() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.changeTabListener);
      });
    }
    _changeTab(e) {
      e.preventDefault();

      const currentTab = e.currentTarget;
      const currentType = currentTab.dataset.type;

      this.tabs = this.tabs.map((tab) => {
        tab.classList.remove('active');

        return tab;
      });
      currentTab.classList.add('active');

      this.cards = this.cards.map((card) => {
        card.style.display = card.dataset.type === currentType ? 'block' : 'none';

        return card;
      });
    }
  }
  if (!window.customElements.get('predictive-search-results')) {
    window.customElements.define('predictive-search-results', PredictiveSearchResults);
  }

  class SearchSuggestion extends HTMLElement {
    constructor() {
      super();

      this.clickListener = this._click.bind(this);
    }
    connectedCallback() {
      this.addEventListener('click', this.clickListener);
    }
    _click(e) {
      e.preventDefault();

      document.dispatchEvent(
        new CustomEvent('term:click', {
          bubbles: true,
          detail: {
            term: this.innerText,
          },
        })
      );
    }
  }
  if (!window.customElements.get('search-suggestion')) {
    window.customElements.define('search-suggestion', SearchSuggestion);
  }

  class XNewSlideshow extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (typeof Splide === 'undefined') {
        const script = document.createElement('script');

        script.addEventListener('load', () => {
          this._run();
        });
        script.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
        script.defer = 'defer';

        document.body.appendChild(script);
      } else {
        this._run();
      }
    }
    _run() {
      new Splide(this).mount();
    }
  }
  if (!window.customElements.get('x-new-slideshow')) {
    window.customElements.define('x-new-slideshow', XNewSlideshow);
  }

  class NewHeader extends HTMLElement {
    constructor() {
      super();

      this.scrolled = window.scrollY;
      this.onWheelListener = this._onWheel.bind(this);
      this.onResizeListener = this._onResize.bind(this);
      this.onScrollListener = this._onScroll.bind(this);
    }
    connectedCallback() {
      window.addEventListener('scroll', this.onScrollListener);
      window.addEventListener('wheel', this.onWheelListener);
      window.addEventListener('resize', this.onResizeListener);
    }
    _onScroll() {
      if (Math.abs(this.scrolled - window.scrollY) >= 50) {
        if (this.scrolled > window.scrollY) {
          this.classList.remove('small');
        } else {
          this.classList.add('small');
        }
      }

      this.scrolled = window.scrollY;
    }
    _onWheel(e) {
      if (e.deltaY > 0) {
        this.classList.add('small');
      } else {
        this.classList.remove('small');
      }
    }
    _onResize() {
      if (window.scrollY) {
        this.classList.add('small');
      } else {
        this.classList.remove('small');
      }
    }
  }
  if (!window.customElements.get('new-header')) {
    window.customElements.define('new-header', NewHeader);
  }

  class MenuAccordion extends HTMLElement {
    constructor() {
      super();

      this.onClickListener = this._onClick.bind(this);
    }
    connectedCallback() {
      this.querySelector('.new-footer__menu-title').addEventListener('click', this.onClickListener);
    }
    _open() {
      this.classList.add('open');
    }
    _close() {
      this.classList.remove('open');
    }
    _isOpened() {
      return this.classList.contains('open') === true;
    }
    _onClick(e) {
      e.preventDefault();

      if (window.innerWidth < 1024) {
        if (this._isOpened()) {
          this._close();
        } else {
          this._open();
        }
      }
    }
  }
  if (!window.customElements.get('menu-accordion')) {
    window.customElements.define('menu-accordion', MenuAccordion);
  }

  class CartDrawerDiscount extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('button');
      this.onApplyCouponListener = this._onApplyCoupon.bind(this);
      this.onRemoveCouponListener = this._onRemoveCoupon.bind(this);
    }
    connectedCallback() {
      this.button.addEventListener('click', this.onApplyCouponListener);
      document.querySelector('#remove-coupon')?.addEventListener('click', this.onRemoveCouponListener);
    }
    disconnectedCallback() {
      this.button.removeEventListener('click', this.onApplyCouponListener);
      document.querySelector('#remove-coupon')?.removeEventListener('click', this.onRemoveCouponListener);
    }
    async _onApplyCoupon() {
      this._onApply(this.querySelector('input').value);
    }
    async _onRemoveCoupon() {
      this._onApply('null');
    }
    async _onApply(couponCode) {
      try {
        await fetch('/checkout?discount=' + couponCode).then((r) => r.text());

        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('cart-drawer-discount')) {
    window.customElements.define('cart-drawer-discount', CartDrawerDiscount);
  }

  class XInstallments extends HTMLElement {
    constructor() {
      super();

      this.product = null;
      this.selectedVariant = null;
      this.productHandle = this.getAttribute('handle');
      this.onChangeVariantListener = this._onChangeVariant.bind(this);
    }
    connectedCallback() {
      document.addEventListener('variant:change', this.onChangeVariantListener);

      this._load().then((t) => t._render());
    }
    async _onChangeVariant(event) {
      event.preventDefault();

      this._load().then((t) => t._render());
    }
    async _load() {
      try {
        if (this.product === null) {
          this.product = await fetch('/products/' + this.productHandle + '.js', {
            headers: {
              'Content-Type': 'application/json',
            },
          }).then((r) => r.json());
        }

        this.selectedVariant = this.product.variants[0];

        const url = new URL(window.location.href);
        const variantId = url.searchParams.get('variant');

        if (variantId) {
          this.selectedVariant = this.product.variants.find((v) => v.id == variantId);
        }

        return this;
      } catch (err) {
        console.error(err);
      }
    }
    _render() {
      const installmentAmount = window.themeVariables.settings.installments;

      this.innerHTML = 'ou [installment_amount]x de [installment_value]'
        .replace('[installment_amount]', installmentAmount)
        .replace('[installment_value]', formatMoney(this.selectedVariant.price / 100 / installmentAmount));
    }
  }
  if (!window.customElements.get('x-installments')) {
    window.customElements.define('x-installments', XInstallments);
  }

  class ATCModal extends HTMLElement {
    constructor() {
      super();

      this.button = document.querySelector('button[type="submit"]');
    }
    connectedCallback() {
      window.addEventListener('scroll', this._show.bind(this));

      this._show.call(this);
    }
    _show() {
      try {
        const footerInfo = document.querySelector('.shopify-section-group-footer-group');

        if (footerInfo && this.button) {
          const footerInfoRect = footerInfo.getBoundingClientRect();
          const buttonInfoRect = this.button.getBoundingClientRect();

          if (buttonInfoRect.top + buttonInfoRect.height <= 0 && footerInfoRect.top > window.innerHeight) {
            this.classList.add('show');
          } else {
            this.classList.remove('show');
          }
        }
      } catch (err) {
        console.error(err);
      }
    }
  }

  if (!window.customElements.get('atc-modal')) {
    window.customElements.define('atc-modal', ATCModal);
  }

  class OfferInstallments extends HTMLElement {
    constructor() {
      super();
    }
  }
  if (!window.customElements.get('offer-installments')) {
    window.customElements.define('offer-installments', OfferInstallments);
  }

  /**
   * Bundle Button
   */
  class BundleCardButton extends HTMLElement {
    constructor() {
      super();
      this.id = this.getAttribute('item-id');
      this.input = this.querySelector('input[type="checkbox"]');
      this.label = this.querySelector('.product-card-bundle__label');
    }
    connectedCallback() {
      this.input.addEventListener('change', this._onChange.bind(this));
    }
    _onChange(e) {
      e.preventDefault();

      const input = e.currentTarget;
      const parent = input.closest('label');

      if (input.checked) {
        parent.ariaSelected = true;
        this.label.innerHTML = 'Adicionado';
        document.dispatchEvent(
          new CustomEvent('bundle:add', {
            bubbles: true,
            detail: {
              handle: input.value,
            },
          })
        );
      } else {
        parent.ariaSelected = false;
        this.label.innerHTML = 'Adicionar item';
        document.dispatchEvent(
          new CustomEvent('bundle:remove', {
            bubbles: true,
            detail: {
              handle: input.value,
            },
          })
        );
      }
    }
  }

  if (!window.customElements.get('bundle-card-button')) {
    window.customElements.define('bundle-card-button', BundleCardButton);
  }

  /**
   * Bundle Sidebar
   */
  class BundleItem extends HTMLElement {
    constructor() {
      super();

      this.buttonRemove = this.querySelector('button');
    }
    connectedCallback() {
      this.buttonRemove.addEventListener('click', this._onRemove.bind(this));
    }
    _onRemove(e) {
      e.preventDefault();

      document.dispatchEvent(
        new CustomEvent('bundle:remove', {
          bubbles: true,
          detail: {
            handle: this.dataset.handle,
          },
        })
      );
    }
  }

  if (!window.customElements.get('bundle-item')) {
    window.customElements.define('bundle-item', BundleItem);
  }

  /**
   * Bundle Sidebar
   */
  class BundleSidebar extends HTMLElement {
    constructor() {
      super();

      this.bundleId = Date.now();
      this.targetPrice = parseFloat(this.getAttribute('target-price') || 0) * 100;
      this.template = `
        <bundle-item class="bundle__item bundle__item--[product_handle]" data-handle="[product_handle]" [is_bundle]>
          <input type="hidden" name="items[][id]" value="[variant_id]"/>
          <input type="hidden" name="items[][quantity]" value="1"/>
          <input type="hidden" name="items[][properties[_bundle]]" value="kit_[i]"/>
          <div>
            <img 
              src="[image_src]"
              alt="[product_title]"
              width="50"
              height="50"
              loading="eager"
              class="bundle__image"
            >
          </div>

          <h3 class="bold">[product_title]</h3>

          <button type="button">
            <svg role="presentation" stroke-width="2" width="24" height="24" focusable="false" class="icon icon--close" viewBox="0 0 24 24"><path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path></svg>
          </button>
        </bundle-item>
      `;

      this.bundleProduct = null;
      this.bundleProductHandle = this.getAttribute('product');
      this.totalPrice = 0;
      this.totalItems = 0;
      this.items = [];
      this.container = this.querySelector('.bundle__items-list');
      this.button = this.querySelector('form .button');
    }
    connectedCallback() {
      document.addEventListener('bundle:add', this._onAddBundleItem.bind(this));
      document.addEventListener('bundle:remove', this._onRemoveBundleItem.bind(this));
      document.addEventListener('variant:add', this._onVariantAdded.bind(this));

      this.loadBundleProduct(this.bundleProductHandle);
    }
    async loadBundleProduct(handle) {
      if (this.bundleProduct === null) {
        try {
          this.bundleProduct = await fetch(`/products/${handle}.js`).then((r) => r.json());
        } catch (err) {
          console.error(err);
        }
      }
    }
    _onVariantAdded() {
      this.bundleId = Date.now();
    }
    addItem(data, isBundle = false) {
      return this.template
        .replace(/\[image_src\]/gi, data.image)
        .replace(/\[product_id\]/gi, data.id)
        .replace(/\[product_title\]/gi, data.title)
        .replace(/\[product_handle\]/gi, data.handle)
        .replace(/\[variant_id\]/gi, data.variant_id)
        .replace(/\[is_bundle\]/gi, isBundle ? 'data-is-bundle="true"' : '')
        .replace(/\[i\]/gi, this.bundleId);
    }
    async _onAddBundleItem(e) {
      try {
        const { handle } = e.detail;
        const product = await fetch(`/products/${handle}.js`).then((r) => r.json());

        if (this.items.length === 0) {
          this.items.push(this.bundleProduct);
        }

        this.items.push(product);
        this._render(this.items);
      } catch (err) {
        console.error('[BUNDLE]', err);
      }
    }
    _onRemoveBundleItem(e) {
      try {
        const { handle } = e.detail;
        this.items = this.items.filter((item) => item.handle !== handle);

        if (this.items.every((item) => item.id === this.bundleProduct.id)) {
          this.items.pop();
        }

        this._render(this.items);
      } catch (err) {
        console.error('[BUNDLE]', err);
      }
    }
    _render(items) {
      try {
        this.totalPrice = items.reduce((acum, item) => {
          acum += parseFloat(item.variants[0].price);
          return acum;
        }, 0);

        document.querySelectorAll('.product-card-bundle__button').forEach((bundleButton) => {
          const input = bundleButton.querySelector('input[type="checkbox"]');

          if (input) {
            const isSelected = items.some((item) => item.handle === bundleButton.getAttribute('handle'));
            const label = bundleButton.querySelector('.product-card-bundle__label');
            bundleButton.ariaSelected = isSelected;
            input.checked = isSelected;
            label.innerHTML = isSelected ? 'Adicionado' : 'Adicionar item';
          }
        });

        this.container.innerHTML = items
          .map((item) => {
            return this.addItem(
              {
                image: item.featured_image,
                id: item.id,
                title: item.title,
                handle: item.handle,
                variant_id: item.variants[0].id,
              },
              this.bundleProductHandle === item.handle
            );
          })
          .join('');

        console.log('>>>', this.totalPrice, this.targetPrice);
        if (this.button) {
          this.button.disabled = !(this.totalPrice >= this.targetPrice);
        }
      } catch (err) {
        console.error('[BUNDLE]', err);
      }
    }
  }

  if (!window.customElements.get('bundle-sidebar')) {
    window.customElements.define('bundle-sidebar', BundleSidebar);
  }

  /**
   * Back the top
   */
  class BackTheTop extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('a');
    }
    connectedCallback() {
      this.button.addEventListener('click', this._onClick.bind(this));
      window.addEventListener('scroll', this._onScroll.bind(this));
    }
    _onClick(e) {
      e.preventDefault();

      window.scrollTo(0, 0);
    }
    _onScroll() {
      try {
        const footerInfo = document.querySelector('.shopify-section-group-footer-group');

        if (footerInfo) {
          const footerInfoRect = footerInfo.getBoundingClientRect();

          if (footerInfoRect.top > window.innerHeight) {
            this.classList.remove('shown');
          } else {
            this.classList.add('shown');
          }
        }
      } catch (err) {
        console.error(err);
      }
    }
  }

  if (!window.customElements.get('back-to-top')) {
    window.customElements.define('back-to-top', BackTheTop);
  }

  /**
   * Back in stock
   */
  class BackInStock extends HTMLElement {
    constructor() {
      super();

      this.product = this.getAttribute('product') || null;
    }
    connectedCallback() {
      this.querySelector('form').addEventListener('submit', this._onSubmit.bind(this));
    }
    disconnectedCallback() {
      this.querySelector('form').removeEventListener('submit', this._onSubmit.bind(this));
    }
    _onSubmit(e) {
      e.preventDefault();

      try {
        if (this.product.length === 0) {
          throw new Error('O produto não está definido.');
        }

        const form = this.querySelector('form');
        const email = form.querySelector('[name="email"]');
        const listID = form.querySelector('[name="listID"]').value;
        const button = form.querySelector('.back-in-stock__button--submit');

        button.innerHTML = 'Enviando...';
        button.disabled = true;
        email.disabled = true;

        this.querySelector('.back-in-stock__content').style.display = 'block';
        this.querySelector('.back-in-stock__result').style.display = 'none';

        global.insider_object = window.insider_object || {};
        global.insider_object.user = {
          email: email.value,
          language: 'pt-br',
          gdpr_optin: true,
          email_optin: true,
          list_id: [listID],
          custom: {
            back_in_stock: this.product,
          },
        };

        setTimeout(() => {
          Insider.eventManager.dispatch('init-manager:re-initialize');
        }, 100);

        setTimeout(() => {
          const form = this.querySelector('form');
          const email = form.querySelector('[name="email"]');
          const button = form.querySelector('.back-in-stock__button--submit');

          button.innerHTML = 'Enviar';
          button.disabled = false;
          email.disabled = false;

          this.querySelector('.back-in-stock__content').style.display = 'none';
          this.querySelector('.back-in-stock__result').style.display = 'block';
        }, 1750);
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('back-in-stock')) {
    window.customElements.define('back-in-stock', BackInStock);
  }

  /** Gift bar */
  class GiftBar extends HTMLElement {
    constructor() {
      super();

      this.shippingValue = parseFloat(this.getAttribute('shipping') || 0);
      this.progressHtml = this.querySelector('#gift-bar-progress-bar');
    }

    connectedCallback() {
      window.addEventListener('DOMContentLoaded', () => {
        fetch('/cart.js')
          .then((r) => r.json())
          .then((c) => {
            document.dispatchEvent(
              new CustomEvent('giftbar:refresh', {
                bubbles: true,
                detail: {
                  cart: c,
                },
              })
            );
          });
      });

      document.addEventListener('giftbar:refresh', this.render.bind(this));
    }

    /**
     * Fetch product
     *
     * @param {String} handle Product handle
     * @returns {Object} Product
     */
    async fetchProduct(handle) {
      return await fetch(`${Shopify.routes.root}products/${handle}.js`, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((r) => r.json());
    }

    /**
     * Fetch offers products
     *
     * @param {Array} orderGifts Sales Motivator offer array
     * @returns {Array} Order gifts
     */
    async fetchOffersProducts(orderGifts) {
      for (let i = 0, j = orderGifts.length; i < j; i++) {
        try {
          if (orderGifts[i].type === 'shipping') {
            continue;
          }
          const { gifts } = orderGifts[i];

          if (gifts.length === 0) {
            continue;
          }

          const products = await Promise.all(
            gifts.map(async ({ original_url }) => await this.fetchProduct(original_url))
          );

          const giftsData = gifts.map((gift, i) => {
            gift['product'] = products[i];

            return gift;
          });

          orderGifts[i].gifts = giftsData;
        } catch (err) {
          console.error(err);
        }
      }

      return orderGifts;
    }

    /**
     * Get max value
     *
     * @param {Object} offersGift Sales Motivator offer array
     */
    getMaxValue(offersGift) {
      return offersGift.reduce((maxValue, offer) => {
        if (offer.order_minimum > maxValue) {
          maxValue = offer.order_minimum;
        }

        return maxValue;
      }, offersGift[0].order_minimum);
    }

    /**
     * Step tpl
     *
     * @param {String} content Content to render
     * @param {Number} position Position on inside progress bar
     * @param {Boolean} isActive Active
     * @returns {String}
     */
    stepTpl(price, position, isActive) {
      return `
        <span class="gift-bar__step${isActive ? ' active' : ''}" style="--position: ${position};">
          <span>${price > 0 ? formatMoney(price).replace(',00', '') : 'Grátis'}</span>
        </span>
      `;
    }

    /**
     * Render steps
     *
     * @param {Array} offersGift Sales Motivator offer array
     * @param {Number} maxValue Max value
     * @param {Number} cartTotalPrice Cart total price
     */
    renderSteps(offersGift, maxValue, cartTotalPrice) {
      const target = this.querySelector('#gift-bar-steps');

      if (!target) {
        throw new Error('Steps target does not exisit');
      }

      const stepsHtmlList = offersGift.map((offer) => {
        const position = (offer.order_minimum / maxValue).toFixed(2) * 100;

        return this.stepTpl(offer.order_minimum, position, cartTotalPrice > offer.order_minimum);
      });

      target.innerHTML = stepsHtmlList.join(' ');
    }

    /**
     * Render progress
     *
     * @param {Number} progress Progress
     */
    renderProgress(progress = 0) {
      if (!this.progressHtml) {
        throw new Error('Progress bar does not exists.');
      }

      this.progressHtml.style.setProperty('--progress', (progress * 100).toFixed(2));
    }

    /**
     * Render title
     *
     * @param {Array} offersGift Sales Motivator offer array
     * @param {Number} cartTotalPrice Cart total price
     */
    renderTitle(offersGift, cartTotalPrice) {
      let i, j;
      const messages = [
        'Com mais <strong>[remain]</strong> você leva [products]',
        'Só mais <strong>[remain]</strong> você leva [products]',
      ];

      try {
        const target = this.querySelector('#gift-bar-text');

        for (i = 0, j = offersGift.length; i < j && offersGift[i].order_minimum < cartTotalPrice; i++);

        if (i < j) {
          const nextOffer = offersGift[i];
          const messageIndex = i % messages.length;

          target.innerHTML = messages[messageIndex]
            .replace('[remain]', formatMoney(nextOffer.order_minimum - cartTotalPrice))
            .replace('[products]', () => {
              if (nextOffer.type === 'shipping') {
                return `FRETE GRÁTIS`;
              }

              return `mais ${nextOffer.gifts.length} brinde${nextOffer.gifts.length > 1 ? 's' : ''}`;
            });
        } else {
          target.innerHTML = 'Uhu!! Você ganhou <strong>FRETE GRÁTIS</strong> e mais <strong>MUITOS BRINDES!!</strong>';
        }
      } catch (err) {
        throw new Error(err);
      }
    }

    renderItems(offersGift, cartTotalPrice) {
      try {
        const target = this.querySelector('#gift-bar-items');

        if (!target) {
          throw new Error('Gift bar items target does not exist.');
        }

        const offersItems = offersGift
          .map(({ gifts, order_minimum }) => {
            const itemsImages = gifts
              .map(({ product }) => {
                return `
              <img
                src="${product.featured_image}"
                alt="${product.title}"
                width="48"
                height="48"
                loading="lazy"
              >
            `;
              })
              .join('');

            const titles = gifts.map(({ product }) => product.title).join(' + ');

            const listItemImages = `<span class="gift-bar__item-images">${itemsImages}</span>`;
            const listItemTitle = `<span class="gift-bar__item-title">${titles}</span>`;

            return `<li class="gift-bar__items-list-item${order_minimum <= cartTotalPrice ? ' active' : ''}">
              ${listItemImages}
              ${listItemTitle}
            </li>`;
          })
          .join('');

        target.innerHTML = `<ul class="gift-bar__items-list">${offersItems}</ul>`;
      } catch (err) {
        throw new Error(err);
      }
    }

    reorder(offersGift) {
      return offersGift.sort((x, y) => {
        if (x.order_minimum < y.order_minimum) {
          return -1;
        } else if (x.order_minimum > y.order_minimum) {
          return 1;
        }

        return 0;
      });
    }

    /**
     * Render
     *
     * @returns {Null | Undefined}
     */
    render(e) {
      (async () => {
        if (typeof sm_orders_gifts === 'undefined') {
          return null;
        }

        if (sm_orders_gifts.length === 0) {
          return null;
        }

        try {
          if (!sm_orders_gifts.some((offer) => offer.type === 'shipping')) {
            sm_orders_gifts.push({
              type: 'shipping',
              order_minimum: this.shippingValue,
              gifts: [
                {
                  product: {
                    title: 'Frete Grátis',
                    featured_image:
                      'https://cdn.shopify.com/s/files/1/0702/7477/7369/files/free-shipping.png?v=1759937955&width=64',
                  },
                },
              ],
            });
          }

          sm_orders_gifts = this.reorder(sm_orders_gifts);
          this.setAttribute('cart-value', (e.detail?.cart?.total_price / 100).toFixed(2));

          const cartTotalPrice = parseFloat(this.getAttribute('cart-value'));
          const maxValue = this.getMaxValue(sm_orders_gifts);

          this.renderSteps(sm_orders_gifts, maxValue, cartTotalPrice);
          this.renderProgress(cartTotalPrice / maxValue);

          await this.fetchOffersProducts(sm_orders_gifts);

          this.renderTitle(sm_orders_gifts, cartTotalPrice);
          this.renderItems(sm_orders_gifts, cartTotalPrice);
        } catch (err) {
          console.error(err);
        }
      })();
    }
  }
  if (!window.customElements.get('gift-bar')) {
    window.customElements.define('gift-bar', GiftBar);
  }

  /** Section Timer */
  class SectionTimer extends HTMLElement {
    constructor() {
      super();

      this.endAt = this.getAttribute('end-at');
      this.content = this.getAttribute('message');
      this.showDays = this.getAttribute('show-days') === 'true';
      this.restartMidnight = this.getAttribute('restart-midnight') === 'true';
    }
    connectedCallback() {
      this._run.apply(this);
    }
    _template(showDays = false) {
      return `
        <span class="section-header-timer__timer">
          ${
            showDays
              ? '<strong class="section-header-timer__value section-header-timer__value--days">{days}</strong>'
              : ''
          }
          <strong class="section-header-timer__value section-header-timer__value--hours">{hours}</strong>
          <strong class="section-header-timer__value section-header-timer__value--minutes">{minutes}</strong>
          <strong class="section-header-timer__value section-header-timer__value--seconds">{seconds}</strong>
        </span>
      `;
    }
    _render(data = {}, options = {}) {
      options = Object.assign(
        {
          showDays: false,
        },
        options
      );

      const timerContent = Object.keys(data).reduce((content, param) => {
        const re = new RegExp(`\{( )*(${param})( )*\}`, 'gi');

        content = content.replace(re, ('000' + data[param]).slice(-2));

        return content;
      }, this._template(data.days > 0 && options.showDays));

      this.classList.remove('invisible');
      this.innerHTML = this.content.replace('[timer]', timerContent);
    }
    _run() {
      try {
        const [date, time] = this.endAt.split(' ');
        const [day, month, year] = date.split('/');
        const [hours, minutes, seconds] = time.split(':');

        let endAt = new Date(year, month - 1, day, hours, minutes, seconds);

        if (this.restartMidnight === true) {
          endAt = new Date(year, month - 1, day + 1, 0, 0, 0);
        }

        const setIntervalTime = setInterval(() => {
          const now = new Date().getTime();
          const distance = endAt.getTime() - now;
          const remainDays = Math.floor(distance / (1000 * 60 * 60 * 24));
          const remainHours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const remainMinutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const remainSeconds = Math.floor((distance % (1000 * 60)) / 1000);

          if (distance <= 0) {
            // this.remove();
            return clearInterval(setIntervalTime);
          }

          this._render(
            {
              days: remainDays,
              hours: remainHours,
              minutes: remainMinutes,
              seconds: remainSeconds,
            },
            {
              showDays: this.showDays,
            }
          );
        }, 1000);
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('section-timer')) {
    window.customElements.define('section-timer', SectionTimer);
  }

  class SimpleTimer extends HTMLElement {
    constructor() {
      super();

      this.endAt = this.getAttribute('end-at');
      this.message = this.getAttribute('message');
      this.showDays = this.getAttribute('show-days') === 'true';
      this.restartMidnight = true;
    }
    connectedCallback() {
      this.run.apply(this);
    }
    template() {
      return `
        <span class="simple-timer__timer">
          <span class="simple-timer__timer-message">{message}</span>
          <span class="simple-timer__timer-timer">{timer}</span>
        </span>
      `;
    }
    render(data = {}) {
      const timerContent = Object.keys(data).reduce((content, param) => {
        const re = new RegExp(`\{( )*(${param})( )*\}`, 'gi');

        content = content.replace(re, data[param]);

        return content;
      }, this.template());

      this.innerHTML = timerContent;
    }
    run() {
      try {
        const [date, time] = this.endAt.split(' ');
        const [day, month, year] = date.split('/');
        const [hours, minutes, seconds] = time.split(':');

        let endAt = new Date(year, month - 1, day, hours, minutes, seconds);

        if (this.restartMidnight === true) {
          endAt = new Date(year, month - 1, day + 1, 0, 0, 0);
        }

        const setIntervalTime = setInterval(() => {
          const now = new Date().getTime();
          const distance = endAt.getTime() - now;
          const remainDays = Math.floor(distance / (1000 * 60 * 60 * 24));
          const remainHours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const remainMinutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const remainSeconds = Math.floor((distance % (1000 * 60)) / 1000);

          if (distance <= 0) {
            // this.remove();
            return clearInterval(setIntervalTime);
          }

          this.render({
            message: this.message,
            timer:
              (this.showDays ? remainDays + 'd ' : '') +
              ('0' + remainHours).slice(-2) +
              ':' +
              ('0' + remainMinutes).slice(-2) +
              ':' +
              ('0' + remainSeconds).slice(-2),
          });
        }, 1000);
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('simple-timer')) {
    window.customElements.define('simple-timer', SimpleTimer);
  }

  class CheckoutButton extends HTMLElement {
    constructor() {
      super();

      this.lock = false;
      this.variantId = this.getAttribute('variant');
    }
    connectedCallback() {
      this.addEventListener('click', this._buyNow.bind(this));
    }
    async _buyNow(e) {
      e.preventDefault();

      if (!this.variantId) {
        return;
      }

      if (this.lock == true) {
        return;
      }

      try {
        this.lock = true;

        this.classList.add('loading');

        await fetch('/cart/clear.json')
          .then((r) => {
            document.body.classList.toggle('invisible');
          })
          .then(async () => {
            await fetch('/cart/add.js', {
              method: 'post',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: this.variantId,
                quantity: 1,
              }),
            }).then((r) => r.json());

            setTimeout(() => {
              window.location.pathname = '/checkout';
            }, 500);
          });
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('checkout-button')) {
    window.customElements.define('checkout-button', CheckoutButton);
  }
})(window);
